module.exports = __webpack_public_path__ + "static/media/upload.c5090a6e.svg";